var _a;
import { UnitSuffix } from '../../defs';
import { CENTIMETER_PIXEL_VALUE } from '../../internal/constants';
import { noConvert } from '../../internal/converters';
import { pixel } from '../../internal/converters/pixel';
var centimeterToPixel = function (value) {
    return value * CENTIMETER_PIXEL_VALUE;
};
var centimeterToMillimeter = function (value) {
    return pixel.mm(centimeterToPixel(value));
};
var centimeterToQuarter = function (value) {
    return pixel.Q(centimeterToPixel(value));
};
var centimeterToInch = function (value) {
    return pixel.in(centimeterToPixel(value));
};
var centimeterToPica = function (value) {
    return pixel.pc(centimeterToPixel(value));
};
var centimeterToPoint = function (value) {
    return pixel.pt(centimeterToPixel(value));
};
var centimeterToREM = function (value, options) {
    return pixel.rem(centimeterToPixel(value), options);
};
var centimeterToEM = function (value, options) {
    return pixel.em(centimeterToPixel(value), options);
};
var centimeterToViewWidth = function (value, options) {
    return pixel.vw(centimeterToPixel(value), options);
};
var centimeterToViewHeight = function (value, options) {
    return pixel.vh(centimeterToPixel(value), options);
};
var centimeterToViewMin = function (value, options) {
    return pixel.vmin(centimeterToPixel(value), options);
};
var centimeterToViewMax = function (value, options) {
    return pixel.vmax(centimeterToPixel(value), options);
};
export var centimeter = (_a = {},
    _a[UnitSuffix.Pixel] = centimeterToPixel,
    _a[UnitSuffix.Centimeter] = noConvert,
    _a[UnitSuffix.Millimeter] = centimeterToMillimeter,
    _a[UnitSuffix.Quarter] = centimeterToQuarter,
    _a[UnitSuffix.Inch] = centimeterToInch,
    _a[UnitSuffix.Pica] = centimeterToPica,
    _a[UnitSuffix.Point] = centimeterToPoint,
    _a[UnitSuffix.REM] = centimeterToREM,
    _a[UnitSuffix.EM] = centimeterToEM,
    _a[UnitSuffix.ViewWidth] = centimeterToViewWidth,
    _a[UnitSuffix.ViewHeight] = centimeterToViewHeight,
    _a[UnitSuffix.ViewMin] = centimeterToViewMin,
    _a[UnitSuffix.ViewMax] = centimeterToViewMax,
    _a);
//# sourceMappingURL=centimeter.js.map